import 'reflect-metadata'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
// import './styles/globals.scss'

import './_utils/utils'
import { setupAxios } from './config/axios-setup'
import { setupLocalization } from './config/locale-setup'
import { setupAqe } from './config/aqe-setup'
import { getRuntimeConfig } from './config/runtime-config'
import { Maintenance503 } from './components/503/maintenance-503'
import { App } from './app'
import { AppRoot } from './core/boot/app-root'
import { startVisibilityObserver } from './_utils/visibility-api'
import { setupDayjs } from './config/dayjs-setup'
import { installBrandVoiceDebug } from './components/domain-ai-settings/brand-voice/brand-voice-debug'
import Highcharts from 'highcharts'
import { BOOT_MARKS, markBootStep } from './core/boot/boot-marks'

markBootStep(BOOT_MARKS.bundleStart)

/**
 * Configures the app from the runtime configuration and renders it.
 */
function renderApp(): void {
    startVisibilityObserver()

    Highcharts.setOptions({
        chart: {
            backgroundColor: 'transparent',
        },
        title: {
            style: { color: 'var(--color-black)' },
        },
        legend: {
            itemStyle: { color: 'var(--color-black)' },
            itemHoverStyle: { color: 'var(--color-dark-gray)' },
        },
    })

    let AppComponent: any = App
    if (getRuntimeConfig().MAINT_MODE?.trim() === 'on') {
        AppComponent = Maintenance503
    }

    const container = document.getElementById('root')

    ReactDOM.createRoot(container!).render(<AppRoot app={<AppComponent />} />)
}

const cfg = getRuntimeConfig()

setupAxios()
setupDayjs()
setupLocalization()
setupAqe(cfg)
installBrandVoiceDebug()

renderApp()
